import { FieldValues, Path, UseFormSetError } from "react-hook-form";

export function addServerErrors<T extends FieldValues>(
    errors: { [P in keyof T]?: string[] },
    setError: UseFormSetError<T>
) {
    return Object.keys(errors).forEach((key) => {
        const k = key as Path<T>;
        const msg = errors[key as keyof T];
        if (msg) {
            setError(k, {
                type: "server",
                message: msg.join(". "),
            });
        }
    });
}

export function getServerErrors<T extends FieldValues>(errors: { [P in keyof T]?: string[] }) {
    return Object.keys(errors).reduce((acc, key) => {
        const k = key as Path<T>;
        const msg = errors[key as keyof T];
        if (msg) {
            acc[k as unknown as keyof T] = msg.join(". ");
        }
        return acc;
    }, {} as { [P in keyof T]?: string });
}
